import React from "react";
import { useChroma } from "../../../skins/shared/hooks/useChroma";
import styled from "styled-components";
import { Carousel, CarouselNext, CarouselPrevious, CarouselSlide, CarouselSlides, CarouselViewport, } from "../../../components/Carousel";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { ArticleCoveredCard } from "../../../molecules/ArticleCoveredCard";
const CoveredCardSlide = ({ content, slideIndex, slideTotal, ...props }) => {
    return (React.createElement(CarouselSlide, { ...props },
        React.createElement(AnalyticsProvider, { uiLocation: `slide[${slideIndex + 1}:${slideTotal}]` },
            React.createElement(ArticleCoveredCard, { content: content }))));
};
const _MastheadCarousel = ({ contentList, ...props }) => {
    const chroma = useChroma();
    const breakpoints = "breakpoints" in chroma ? chroma.breakpoints : null;
    const carouselBreakpointOptions = breakpoints
        ? {
            [`(max-width: ${breakpoints?.mobile})`]: {
                align: "center",
            },
        }
        : undefined;
    return (React.createElement(AnalyticsProvider, { uiLocation: "carousel" },
        React.createElement(Carousel, { draggable: true, axis: "x", breakpoints: carouselBreakpointOptions, ...props },
            React.createElement("div", { className: "carousel-triggers" },
                React.createElement(CarouselPrevious, null),
                React.createElement(CarouselNext, null)),
            React.createElement(CarouselViewport, { tabIndex: 0 },
                React.createElement(CarouselSlides, null, contentList &&
                    contentList.map((item, index) => (React.createElement(CoveredCardSlide, { content: item, key: index, slideIndex: index, slideTotal: contentList.length }))))))));
};
export const MastheadCarousel = styled(_MastheadCarousel) ``;
//# sourceMappingURL=MastheadCarousel.js.map